<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26"
    height="24"
    viewBox="0 0 26 24"
    fill="none"
  >
    <path
      d="M20.3809 2.125C21.3012 2.125 22.1831 2.48869 22.8379 3.13477L22.8389 3.13379L24.7178 4.97363C25.0459 5.29881 25.3065 5.68596 25.4844 6.1123C25.6622 6.53861 25.7537 6.99609 25.7539 7.45801C25.7541 7.92006 25.6629 8.37811 25.4854 8.80469C25.3088 9.2288 25.0499 9.61318 24.7246 9.9375L24.7256 9.93848L12.6875 21.9766C12.0312 22.6324 11.1408 23.001 10.2129 23.001C9.28515 23.0009 8.39549 22.6324 7.73926 21.9766L1.02051 15.2227L1.02148 15.2217C0.367881 14.5657 0 13.6781 0 12.752C4.41516e-05 11.8247 0.368263 10.9355 1.02344 10.2793L2.90234 8.40039C3.5583 7.74718 4.44635 7.37988 5.37207 7.37988C6.28967 7.4058 7.16019 7.73247 7.82227 8.38184L10.2383 10.7236L17.917 3.13965C18.5724 2.48992 19.4577 2.125 20.3809 2.125Z"
      fill="white"
    />
    <path
      d="M23.311 8.52446L11.2735 20.562C10.9922 20.8431 10.6109 21.001 10.2132 21.001C9.81556 21.001 9.43418 20.8431 9.1529 20.562L2.43852 13.812C2.15772 13.5307 2 13.1495 2 12.7521C2 12.3547 2.15772 11.9735 2.43852 11.6923L4.31352 9.81728C4.59465 9.53733 4.97522 9.38015 5.37196 9.38015C5.7687 9.38015 6.14928 9.53733 6.4304 9.81728L10.2507 13.5223L19.322 4.56259C19.6031 4.28236 19.9839 4.125 20.3809 4.125C20.7778 4.125 21.1586 4.28236 21.4398 4.56259L23.3101 6.39446C23.4507 6.53385 23.5624 6.6997 23.6386 6.88245C23.7149 7.06521 23.7542 7.26125 23.7543 7.45927C23.7543 7.65729 23.7152 7.85336 23.6391 8.03618C23.5631 8.21901 23.4516 8.38496 23.311 8.52446Z"
      fill="#07A721"
    />
  </svg>
</template>

<script>
export default {};
</script>
